import find from 'lodash/find'
import map from 'lodash/map'
import React from 'react'
import { useAppSetting } from '@ztechapps/common.hook'
import { jsonTryParse } from '@ztechapps/common.utils'

export const useTaxPresetsSetting = ({ appSettingKey }) => {
  const { setting } = useAppSetting({ appSettingKey })
  const [taxPresets, setTaxPresets] = React.useState()
  const [defaultTaxPreset, setDefaultTaxPreset] = React.useState()

  React.useEffect(() => {
    if (setting?.value) {
      let parsedTaxPresets = jsonTryParse(setting?.value)
      parsedTaxPresets = map(parsedTaxPresets, (item) => {
        return { ...item, label: item?.name }
      })
      setTaxPresets(parsedTaxPresets)

      const defaultTaxPreset = find(parsedTaxPresets, (item) => {
        return item?.isDefault
      })
      setDefaultTaxPreset(defaultTaxPreset)
    }
  }, [setting])

  return { taxPresets, defaultTaxPreset }
}
